/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P3_Today_NoteInputs */

const en_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy all Plus features and content`)
};

const ar_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمتع بجميع ميزات ومحتوى بلس`)
};

const de_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genießen Sie alle Plus-Funktionen und -Inhalte`)
};

const es_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfruta de todas las funciones y contenidos Plus`)
};

const fr_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profitez de toutes les fonctionnalités et contenus Plus`)
};

const it_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goditi tutte le funzionalità e i contenuti Plus`)
};

const ja_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusの全機能とコンテンツをお楽しみください`)
};

const ko_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 Plus 기능과 콘텐츠를 즐기세요`)
};

const pt_br_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproveite todos os conteúdos e funcionalidades Plus`)
};

const ru_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользуйтесь всеми функциями и контентом Plus`)
};

const th_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินไปกับคุณสมบัติและเนื้อหา Plus ทั้งหมด`)
};

const tr_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Plus özelliklerinin ve içeriğinin keyfini çıkar`)
};

const zh_cn_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`享受所有 Plus 功能与内容`)
};

const zh_tw_subscription_walkthrough_p3_today_note = /** @type {(inputs: Subscription_Walkthrough_P3_Today_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`享受所有 Plus 功能與內容`)
};

/**
* | output |
* | --- |
* | "Enjoy all Plus features and content" |
*
* @param {Subscription_Walkthrough_P3_Today_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p3_today_note = /** @type {((inputs?: Subscription_Walkthrough_P3_Today_NoteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P3_Today_NoteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "de") return de_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "es") return es_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "it") return it_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "th") return th_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p3_today_note(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p3_today_note(inputs)
	return zh_tw_subscription_walkthrough_p3_today_note(inputs)
});